"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof3 = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StoredCardsCheckout = StoredCardsCheckout;
exports.normalizeDeleteUndoSeconds = normalizeDeleteUndoSeconds;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = _interopRequireWildcard(require("react"));
var _elements = require("@reservamos/elements");
var _reactRedux = require("react-redux");
var _reactI18next = require("react-i18next");
var _useGrowthBookFeatureValue = _interopRequireDefault(require("@/components/GrowthBookProvider/useGrowthBookFeatureValue"));
var _errorMonitoring = _interopRequireDefault(require("@/errorMonitoring"));
var _useBasisTheoryCvvElement = require("@/hooks/libs/useBasisTheoryCvvElement");
var _useBasisTheoryInstallments = require("@/hooks/purchase/payments/basisTheory/useBasisTheoryInstallments");
var _useStoredCards2 = require("@/hooks/purchase/payments/basisTheory/useStoredCards");
var _useStoredCardSubmit = require("@/hooks/purchase/payments/basisTheory/useStoredCardSubmit");
var _useCanSaveAuthenticatedCard = require("@/hooks/store/useCanSaveAuthenticatedCard");
var _webview = require("@/utils/webview");
var _storedCards = require("services/storedCards");
var _BasisTheoryNewCardForm = require("./BasisTheoryNewCardForm");
var _BtInstallmentsSelector = require("./components/BtInstallmentsSelector");
var _EncryptedNotice = require("./EncryptedNotice");
var _PendingCardDeletionNotice = require("./PendingCardDeletionNotice");
var _SavedCardsDialog = require("./SavedCardsDialog");
var _SavedPaymentCard = require("./SavedPaymentCard");
var _StoredCardCvvDialog = require("./StoredCardCvvDialog");
var _StoredCardDeletionDialog = require("./StoredCardDeletionDialog");
var _ViewSavedCardsButton = require("./ViewSavedCardsButton");
var _savedCards = require("@/metrics/user-analytics/savedCards");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof3(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var INLINE_CARD_LIMIT = 2;
var DEFAULT_DELETE_UNDO_SECONDS = 8;
var DEFAULT_DELETION_MODE = 'undo';
var STORED_CARD_INSTALLMENTS_CHECK_MS = 450;
function normalizeDeleteUndoSeconds(value) {
  var seconds = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(seconds) && seconds > 0 ? seconds : DEFAULT_DELETE_UNDO_SECONDS;
}
function isStoredCardDeletionMode(value) {
  return value === 'confirmation_modal' || value === 'undo';
}
function resolveStoredCardDeletionMode(growthBookValue, tenantValue) {
  if (isStoredCardDeletionMode(growthBookValue)) return growthBookValue;
  if (isStoredCardDeletionMode(tenantValue)) return tenantValue;
  return DEFAULT_DELETION_MODE;
}
function renderSavedCardsSkeleton() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-5",
    "aria-busy": "true",
    "aria-live": "polite",
    "data-sentry-component": "renderSavedCardsSkeleton",
    "data-sentry-source-file": "StoredCardsCheckout.tsx"
  }, ['primary-card', 'secondary-card'].map(function (cardKey) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "stored-card-skeleton",
      className: "flex min-h-[66px] items-center gap-3 rounded-xl border border-gray-100 bg-white px-3 py-2",
      key: cardKey
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "h-5 w-5 animate-pulse rounded-full bg-gray-200"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex min-h-[50px] flex-1 items-center gap-3 rounded-xl bg-gray-100 px-3"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "h-10 w-10 animate-pulse rounded-full bg-gray-200"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-1 flex-col gap-2"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "h-3 w-28 animate-pulse rounded bg-gray-200"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "h-3 w-20 animate-pulse rounded bg-gray-200"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "h-3 w-14 animate-pulse rounded bg-gray-200 max-sm:hidden"
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: "h-6 w-6 animate-pulse rounded bg-gray-200"
    }));
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "stored-cards-view-all-skeleton",
    className: "flex min-h-[66px] items-center justify-between rounded-xl border border-gray-200 bg-white px-[18px] py-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-0 flex-1 items-center gap-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-8 w-8 flex-shrink-0 animate-pulse rounded-full bg-gray-200"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-3 w-52 max-w-[70%] animate-pulse rounded bg-gray-200"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-6 w-6 flex-shrink-0 animate-pulse rounded-full bg-gray-200"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "stored-cards-new-card-skeleton",
    className: "flex min-h-[66px] items-center justify-between rounded-xl border border-gray-100 bg-gray-100 px-[18px] py-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex min-w-0 flex-1 items-center gap-3"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-8 w-8 flex-shrink-0 animate-pulse rounded-full bg-gray-200"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-3 w-36 max-w-[60%] animate-pulse rounded bg-gray-200"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-6 w-6 flex-shrink-0 animate-pulse rounded-full bg-gray-200"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "stored-cards-encrypted-notice-skeleton",
    className: "flex min-h-[22px] items-center gap-2 px-1"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-[14px] w-[14px] flex-shrink-0 animate-pulse rounded bg-gray-200"
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "h-3 w-52 max-w-[70%] animate-pulse rounded bg-gray-200"
  })));
}

/** Coordinate the reference saved-card UX on top of the current typed Basis Theory checkout. */
function StoredCardsCheckout(_ref) {
  var active = _ref.active,
    cardErrorOccured = _ref.cardErrorOccured,
    publicKey = _ref.publicKey;
  var _useTranslation = (0, _reactI18next.useTranslation)('purchase'),
    t = _useTranslation.t;
  var canUseStoredCards = (0, _useCanSaveAuthenticatedCard.useCanSaveAuthenticatedCard)();
  var storedCardsCapabilityEnabled = (0, _useCanSaveAuthenticatedCard.useStoredCardsCapabilityEnabled)();
  var installmentsAvailable = (0, _reactRedux.useSelector)(function (state) {
    return Boolean(state.purchase.get('qualifiesForMonthlyInstallments'));
  });
  var sessionKey = (0, _reactRedux.useSelector)(function (state) {
    var _state$reserhubAccoun;
    var user = (_state$reserhubAccoun = state.reserhubAccount) === null || _state$reserhubAccoun === void 0 ? void 0 : _state$reserhubAccoun.get('user');
    if (!user || (0, _typeof2["default"])(user) !== 'object' || !('id' in user)) return '';
    var userId = user.id;
    return typeof userId === 'string' || typeof userId === 'number' ? String(userId) : '';
  });
  var isUserFetched = (0, _reactRedux.useSelector)(function (state) {
    var _state$reserhubAccoun2;
    return Boolean((_state$reserhubAccoun2 = state.reserhubAccount) === null || _state$reserhubAccoun2 === void 0 ? void 0 : _state$reserhubAccoun2.get('isUserFetched'));
  });
  var configuredUndoSeconds = (0, _reactRedux.useSelector)(function (state) {
    var _state$whitelabelConf;
    return (_state$whitelabelConf = state.whitelabelConfig.env.storedCards) === null || _state$whitelabelConf === void 0 ? void 0 : _state$whitelabelConf.deleteUndoWindowSeconds;
  });
  var configuredDeletionMode = (0, _reactRedux.useSelector)(function (state) {
    var _state$whitelabelConf2;
    return (_state$whitelabelConf2 = state.whitelabelConfig.env.storedCards) === null || _state$whitelabelConf2 === void 0 ? void 0 : _state$whitelabelConf2.deletionMode;
  });
  var deletionExperiment = (0, _useGrowthBookFeatureValue["default"])('stored_card_deletion_mode');
  var deletionMode = resolveStoredCardDeletionMode(deletionExperiment, configuredDeletionMode);
  var undoSeconds = normalizeDeleteUndoSeconds(configuredUndoSeconds);
  var _useStoredCards = (0, _useStoredCards2.useStoredCards)({
      enabled: canUseStoredCards,
      sessionKey: sessionKey
    }),
    query = _useStoredCards.query,
    reload = _useStoredCards.reload;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    selection = _useState2[0],
    setSelection = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    payWithNewCard = _useState4[0],
    setPayWithNewCard = _useState4[1];
  var _useState5 = (0, _react.useState)(false),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    hasOpenedNewCardForm = _useState6[0],
    setHasOpenedNewCardForm = _useState6[1];
  var _useState7 = (0, _react.useState)(),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    promotedCardId = _useState8[0],
    setPromotedCardId = _useState8[1];
  var _useState9 = (0, _react.useState)(false),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    showAllCards = _useState10[0],
    setShowAllCards = _useState10[1];
  var _useState11 = (0, _react.useState)(false),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    cvvOpen = _useState12[0],
    setCvvOpen = _useState12[1];
  var _useState13 = (0, _react.useState)(),
    _useState14 = (0, _slicedToArray2["default"])(_useState13, 2),
    deleteModeCardId = _useState14[0],
    setDeleteModeCardId = _useState14[1];
  var _useState15 = (0, _react.useState)(),
    _useState16 = (0, _slicedToArray2["default"])(_useState15, 2),
    pendingDeletion = _useState16[0],
    setPendingDeletion = _useState16[1];
  var _useState17 = (0, _react.useState)(),
    _useState18 = (0, _slicedToArray2["default"])(_useState17, 2),
    deletionConfirmationCard = _useState18[0],
    setDeletionConfirmationCard = _useState18[1];
  var _useState19 = (0, _react.useState)([]),
    _useState20 = (0, _slicedToArray2["default"])(_useState19, 2),
    confirmedDeletedCardIds = _useState20[0],
    setConfirmedDeletedCardIds = _useState20[1];
  var _useState21 = (0, _react.useState)(undoSeconds),
    _useState22 = (0, _slicedToArray2["default"])(_useState21, 2),
    remainingSeconds = _useState22[0],
    setRemainingSeconds = _useState22[1];
  var _useState23 = (0, _react.useState)(false),
    _useState24 = (0, _slicedToArray2["default"])(_useState23, 2),
    deleteFailed = _useState24[0],
    setDeleteFailed = _useState24[1];
  var _useState25 = (0, _react.useState)(),
    _useState26 = (0, _slicedToArray2["default"])(_useState25, 2),
    checkingInstallmentsCardId = _useState26[0],
    setCheckingInstallmentsCardId = _useState26[1];
  var _useState27 = (0, _react.useState)({
      bin: '',
      brand: '',
      expirationComplete: false,
      last4: ''
    }),
    _useState28 = (0, _slicedToArray2["default"])(_useState27, 2),
    newCardDetails = _useState28[0],
    setNewCardDetails = _useState28[1];
  var deleteTimeoutRef = (0, _react.useRef)();
  var installmentsCheckTimeoutRef = (0, _react.useRef)();
  var deletionAttemptRef = (0, _react.useRef)();
  var deletionContextRef = (0, _react.useRef)({
    canUseStoredCards: canUseStoredCards,
    sessionKey: sessionKey
  });
  var mountedRef = (0, _react.useRef)(true);
  var initializedSelectionSessionRef = (0, _react.useRef)();
  var trackedViewSessionRef = (0, _react.useRef)();
  var queriedCards = query.status === 'success' ? query.cards : [];
  var cards = queriedCards.filter(function (card) {
    return !confirmedDeletedCardIds.includes(card.id);
  });
  var selectedCard = (selection === null || selection === void 0 ? void 0 : selection.sessionKey) === sessionKey ? cards.find(function (card) {
    return card.id === selection.cardId;
  }) : undefined;
  var pendingDeleteCardId = pendingDeletion === null || pendingDeletion === void 0 ? void 0 : pendingDeletion.card.id;
  var visibleCards = cards.filter(function (card) {
    return card.id !== pendingDeleteCardId;
  });
  var promotedCard = visibleCards.find(function (card) {
    return card.id === promotedCardId;
  });
  var prioritizedCards = promotedCard ? [promotedCard].concat((0, _toConsumableArray2["default"])(visibleCards.filter(function (card) {
    return card.id !== promotedCard.id;
  }))) : visibleCards;
  var inlineCards = prioritizedCards.slice(0, INLINE_CARD_LIMIT);
  var hasCards = cards.length > 0;
  var selectedCardNeedsCvv = (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.paymentMode.kind) === 'tokenized_with_cvv';
  var cvvElement = (0, _useBasisTheoryCvvElement.useBasisTheoryCvvElement)({
    active: cvvOpen && Boolean(selectedCardNeedsCvv),
    placeholder: t('label.bt_form.stored_card_cvv_placeholder'),
    publicKey: publicKey
  });
  var handleRequireCvv = (0, _react.useCallback)(function () {
    return setCvvOpen(true);
  }, []);
  var activeInstallmentsCard = selectedCard ? {
    kind: 'stored',
    brand: selectedCard.brand,
    cardType: selectedCard.cardType,
    expirationDate: selectedCard.expirationLabel,
    id: selectedCard.id,
    installmentsAvailable: selectedCard.installmentsAvailable,
    last4: selectedCard.last4
  } : !hasCards || payWithNewCard ? _objectSpread({
    kind: 'new'
  }, newCardDetails) : undefined;
  var installments = (0, _useBasisTheoryInstallments.useBasisTheoryInstallments)({
    active: active && query.status !== 'loading',
    card: activeInstallmentsCard
  });
  var storedCardSubmit = (0, _useStoredCardSubmit.useStoredCardSubmit)({
    active: active && Boolean(selectedCard) && !payWithNewCard,
    clientRef: cvvElement.clientRef,
    cvvComplete: cvvElement.isComplete,
    cvvElementRef: cvvElement.elementRef,
    cvvOpen: cvvOpen,
    onRequireCvv: handleRequireCvv,
    selectedCard: active ? selectedCard : undefined,
    selectedInstallmentPlan: installments.selectedPlan,
    sessionKey: sessionKey
  });
  var showStoredCardInstallmentsChecking = (activeInstallmentsCard === null || activeInstallmentsCard === void 0 ? void 0 : activeInstallmentsCard.kind) === 'stored' && installments.shouldRender && installments.eligibilityStatus === 'eligible' && checkingInstallmentsCardId === (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.id);
  var clearInstallmentsCheck = (0, _react.useCallback)(function () {
    if (installmentsCheckTimeoutRef.current) {
      window.clearTimeout(installmentsCheckTimeoutRef.current);
      installmentsCheckTimeoutRef.current = undefined;
    }
    setCheckingInstallmentsCardId(undefined);
  }, []);
  (0, _react.useEffect)(function () {
    return function () {
      mountedRef.current = false;
      if (deleteTimeoutRef.current) window.clearTimeout(deleteTimeoutRef.current);
      if (installmentsCheckTimeoutRef.current) {
        window.clearTimeout(installmentsCheckTimeoutRef.current);
      }
    };
  }, []);
  (0, _react.useLayoutEffect)(function () {
    deletionContextRef.current = {
      canUseStoredCards: canUseStoredCards,
      sessionKey: sessionKey
    };
  }, [canUseStoredCards, sessionKey]);
  (0, _react.useEffect)(function () {
    if (!sessionKey) initializedSelectionSessionRef.current = undefined;
    if (deleteTimeoutRef.current) window.clearTimeout(deleteTimeoutRef.current);
    deleteTimeoutRef.current = undefined;
    deletionAttemptRef.current = undefined;
    setPendingDeletion(undefined);
    setDeletionConfirmationCard(undefined);
    setConfirmedDeletedCardIds([]);
    setDeleteModeCardId(undefined);
    setDeleteFailed(false);
    setShowAllCards(false);
  }, [canUseStoredCards, sessionKey]);
  (0, _react.useEffect)(function () {
    if (!selection) return;
    var sessionChanged = selection.sessionKey !== sessionKey;
    var cardsResolvedWithoutSelection = (query.status === 'success' || query.status === 'empty') && !cards.some(function (card) {
      return card.id === selection.cardId;
    });
    if (sessionChanged || cardsResolvedWithoutSelection) {
      setSelection(undefined);
      setCvvOpen(false);
    }
  }, [canUseStoredCards, cards, query.status, selection, sessionKey]);
  (0, _react.useEffect)(function () {
    if (query.status !== 'success' || !sessionKey) return;
    if (initializedSelectionSessionRef.current === sessionKey) return;
    initializedSelectionSessionRef.current = sessionKey;
    var initialCard = query.cards.find(function (card) {
      return !confirmedDeletedCardIds.includes(card.id) && !card.isExpired && card.paymentMode.kind !== 'unavailable';
    });
    if (!initialCard) return;
    clearInstallmentsCheck();
    setSelection({
      cardId: initialCard.id,
      sessionKey: sessionKey
    });
    setPayWithNewCard(false);
    setCvvOpen(false);
    setPromotedCardId(initialCard.id);
    if (initialCard.installmentsAvailable) {
      setCheckingInstallmentsCardId(initialCard.id);
      installmentsCheckTimeoutRef.current = window.setTimeout(function () {
        installmentsCheckTimeoutRef.current = undefined;
        setCheckingInstallmentsCardId(undefined);
      }, STORED_CARD_INSTALLMENTS_CHECK_MS);
    }
  }, [clearInstallmentsCheck, confirmedDeletedCardIds, query, sessionKey]);
  (0, _react.useEffect)(function () {
    if (query.status !== 'success') return;
    setConfirmedDeletedCardIds(function (currentIds) {
      return currentIds.filter(function (cardId) {
        return query.cards.some(function (card) {
          return card.id === cardId;
        });
      });
    });
  }, [query]);
  (0, _react.useEffect)(function () {
    if (query.status !== 'success' || cards.length === 0) return;
    if (trackedViewSessionRef.current === sessionKey) return;
    trackedViewSessionRef.current = sessionKey;
    (0, _savedCards.trackSavedCardsViewed)(cards);
  }, [cards, query.status, sessionKey]);
  (0, _react.useEffect)(function () {
    if ((pendingDeletion === null || pendingDeletion === void 0 ? void 0 : pendingDeletion.phase) !== 'undo') return undefined;
    var intervalId = window.setInterval(function () {
      setRemainingSeconds(Math.max(0, Math.ceil((pendingDeletion.expiresAt - Date.now()) / 1000)));
    }, 250);
    return function () {
      return window.clearInterval(intervalId);
    };
  }, [pendingDeletion]);
  function selectCard(card) {
    var promote = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (card.isExpired || card.paymentMode.kind === 'unavailable') return;
    clearInstallmentsCheck();
    (0, _savedCards.trackSavedCardSelected)({
      card: card,
      installmentsAvailable: installmentsAvailable,
      position: prioritizedCards.findIndex(function (candidate) {
        return candidate.id === card.id;
      })
    });
    setSelection({
      cardId: card.id,
      sessionKey: sessionKey
    });
    setPayWithNewCard(false);
    setCvvOpen(false);
    setPromotedCardId(promote ? card.id : undefined);
    if (card.installmentsAvailable) {
      setCheckingInstallmentsCardId(card.id);
      installmentsCheckTimeoutRef.current = window.setTimeout(function () {
        installmentsCheckTimeoutRef.current = undefined;
        setCheckingInstallmentsCardId(undefined);
      }, STORED_CARD_INSTALLMENTS_CHECK_MS);
    }
  }
  function clearCardSelection() {
    clearInstallmentsCheck();
    setSelection(undefined);
    setCvvOpen(false);
    setPromotedCardId(undefined);
  }
  function toggleCardSelection(card) {
    if ((selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.id) === card.id) {
      clearCardSelection();
      return;
    }
    selectCard(card);
  }
  function toggleNewCardForm() {
    var willOpenNewCardForm = !payWithNewCard;
    if (willOpenNewCardForm) (0, _savedCards.trackAddNewCardButtonClicked)(cards.length);
    clearInstallmentsCheck();
    setPayWithNewCard(willOpenNewCardForm);
    if (willOpenNewCardForm) setHasOpenedNewCardForm(true);
    setSelection(undefined);
    setCvvOpen(false);
    setPromotedCardId(undefined);
  }
  function undoDelete() {
    if ((pendingDeletion === null || pendingDeletion === void 0 ? void 0 : pendingDeletion.phase) !== 'undo' || pendingDeletion.sessionKey !== sessionKey) return;
    if (deleteTimeoutRef.current) window.clearTimeout(deleteTimeoutRef.current);
    deleteTimeoutRef.current = undefined;
    if (pendingDeletion.wasSelected) {
      setSelection({
        cardId: pendingDeletion.card.id,
        sessionKey: sessionKey
      });
    }
    (0, _savedCards.trackCardDeleteUndone)();
    setPendingDeletion(undefined);
  }
  function prepareCardDeletion(card) {
    var wasSelected = (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.id) === card.id;
    setDeleteFailed(false);
    setDeleteModeCardId(undefined);
    setCvvOpen(false);
    setPromotedCardId(undefined);
    if (wasSelected) setSelection(undefined);
    return wasSelected;
  }
  function deleteCard(_x, _x2, _x3, _x4) {
    return _deleteCard.apply(this, arguments);
  }
  function _deleteCard() {
    _deleteCard = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(card, wasSelected, deletionSessionKey, savedCardsCount) {
      var deletionContextIsCurrent, deletionAttempt, _t;
      return _regenerator["default"].wrap(function (_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            deletionContextIsCurrent = function _deletionContextIsCur() {
              var context = deletionContextRef.current;
              return mountedRef.current && context.canUseStoredCards && context.sessionKey === deletionSessionKey;
            };
            if (!(!deletionContextIsCurrent() || deletionAttemptRef.current)) {
              _context3.next = 1;
              break;
            }
            return _context3.abrupt("return");
          case 1:
            deletionAttempt = {};
            deletionAttemptRef.current = deletionAttempt;
            setPendingDeletion({
              phase: 'deleting',
              card: card,
              sessionKey: deletionSessionKey,
              wasSelected: wasSelected
            });
            _context3.prev = 2;
            _context3.next = 3;
            return (0, _storedCards.deleteStoredCard)(card.id);
          case 3:
            if (deletionAttemptRef.current === deletionAttempt && deletionContextIsCurrent()) {
              (0, _savedCards.trackCardDeleted)(card, savedCardsCount);
              setConfirmedDeletedCardIds(function (currentIds) {
                return [].concat((0, _toConsumableArray2["default"])(currentIds), [card.id]);
              });
            }
            _context3.next = 5;
            break;
          case 4:
            _context3.prev = 4;
            _t = _context3["catch"](2);
            _errorMonitoring["default"].notify({
              error: new Error('Stored card deletion failed'),
              info: {
                stage: 'stored_card_delete'
              }
            });
            if (deletionAttemptRef.current === deletionAttempt && deletionContextIsCurrent()) {
              setDeleteFailed(true);
              if (wasSelected) setSelection({
                cardId: card.id,
                sessionKey: deletionSessionKey
              });
            }
          case 5:
            _context3.prev = 5;
            if (deletionAttemptRef.current === deletionAttempt) {
              deletionAttemptRef.current = undefined;
              if (deletionContextIsCurrent()) setPendingDeletion(undefined);
              deleteTimeoutRef.current = undefined;
            }
            return _context3.finish(5);
          case 6:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 4, 5, 6]]);
    }));
    return _deleteCard.apply(this, arguments);
  }
  function beginUndoDeletion(card) {
    if (pendingDeletion || deletionConfirmationCard) return;
    var wasSelected = prepareCardDeletion(card);
    var undoWindowMs = undoSeconds * 1000;
    setRemainingSeconds(undoSeconds);
    setPendingDeletion({
      phase: 'undo',
      card: card,
      expiresAt: Date.now() + undoWindowMs,
      sessionKey: sessionKey,
      wasSelected: wasSelected
    });
    deleteTimeoutRef.current = window.setTimeout(/*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
      return _regenerator["default"].wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return deleteCard(card, wasSelected, sessionKey, cards.length);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), undoWindowMs);
  }
  function requestCardDeletion(card) {
    if (pendingDeletion || deletionConfirmationCard) return;
    setDeleteModeCardId(undefined);
    if (deletionMode === 'confirmation_modal') {
      setDeletionConfirmationCard(card);
      setShowAllCards(false);
      return;
    }
    beginUndoDeletion(card);
  }
  function confirmCardDeletion() {
    if (!deletionConfirmationCard || pendingDeletion) return;
    var card = deletionConfirmationCard;
    setDeletionConfirmationCard(undefined);
    var wasSelected = prepareCardDeletion(card);
    void deleteCard(card, wasSelected, sessionKey, cards.length);
  }
  function renderCard(card) {
    return /*#__PURE__*/_react["default"].createElement(_SavedPaymentCard.SavedPaymentCard, {
      key: card.id,
      card: card,
      deleteDisabled: Boolean(pendingDeletion || deletionConfirmationCard),
      isActive: (selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.id) === card.id,
      toDelete: deleteModeCardId === card.id,
      onSelect: function onSelect() {
        return toggleCardSelection(card);
      },
      onOpenDeleteMode: function onOpenDeleteMode() {
        if (!pendingDeletion && !deletionConfirmationCard) {
          (0, _savedCards.trackCardDeleteClicked)(card);
          setDeleteModeCardId(card.id);
        }
      },
      onCloseDeleteMode: function onCloseDeleteMode() {
        return setDeleteModeCardId(undefined);
      },
      onConfirmDelete: function onConfirmDelete() {
        return requestCardDeletion(card);
      },
      "data-sentry-element": "SavedPaymentCard",
      "data-sentry-component": "renderCard",
      "data-sentry-source-file": "StoredCardsCheckout.tsx"
    });
  }
  var isResolvingStoredCardsOwner = !(0, _webview.isWebView)() && storedCardsCapabilityEnabled && !sessionKey && !isUserFetched;
  if (isResolvingStoredCardsOwner || query.status === 'loading') {
    return /*#__PURE__*/_react["default"].createElement("div", {
      "data-testid": "stored-cards-checkout-surface",
      className: "rounded-[22px] border border-gray-100 bg-white p-5 shadow-[0_2px_8px_rgba(15,23,42,0.08)]"
    }, renderSavedCardsSkeleton());
  }
  if (!hasCards) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "flex flex-col gap-3"
    }, query.status === 'error' && /*#__PURE__*/_react["default"].createElement(_elements.MessageBox, {
      title: t('saved_card.load_error'),
      borderColor: "warning"
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      className: "mt-2 text-sm font-semibold text-accent-regular underline",
      onClick: reload
    }, t('saved_card.retry'))), /*#__PURE__*/_react["default"].createElement(_BasisTheoryNewCardForm.BasisTheoryNewCardForm, {
      active: active,
      cardErrorOccured: cardErrorOccured,
      monthlySelectedPlan: installments.selectedMonths,
      onCardDetailsChange: setNewCardDetails,
      hasSavedCards: false,
      publicKey: publicKey
    }), /*#__PURE__*/_react["default"].createElement(_BtInstallmentsSelector.BtInstallmentsSelector, installments));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-3",
    "data-sentry-component": "StoredCardsCheckout",
    "data-sentry-source-file": "StoredCardsCheckout.tsx"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "stored-cards-checkout-surface",
    className: "rounded-[22px] border border-gray-100 bg-white p-5 shadow-[0_2px_8px_rgba(15,23,42,0.08)]"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-col gap-5"
  }, deleteFailed && /*#__PURE__*/_react["default"].createElement(_elements.MessageBox, {
    title: t('saved_card.delete_error'),
    borderColor: "warning"
  }), (pendingDeletion === null || pendingDeletion === void 0 ? void 0 : pendingDeletion.phase) === 'undo' && /*#__PURE__*/_react["default"].createElement(_PendingCardDeletionNotice.PendingCardDeletionNotice, {
    onUndo: undoDelete,
    remainingSeconds: remainingSeconds
  }), inlineCards.map(renderCard), visibleCards.length > INLINE_CARD_LIMIT && /*#__PURE__*/_react["default"].createElement(_ViewSavedCardsButton.ViewSavedCardsButton, {
    onClick: function onClick() {
      (0, _savedCards.trackSavedCardsModalOpened)(visibleCards);
      setShowAllCards(true);
    },
    extraCount: visibleCards.length - inlineCards.length
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pt-0.5"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "overflow-hidden rounded-xl border bg-white transition-colors ".concat(payWithNewCard ? 'border-gray-200' : 'border-gray-100')
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    className: "flex min-h-[66px] w-full items-center justify-between bg-gray-100 px-[18px] py-3 text-left",
    onClick: toggleNewCardForm,
    "aria-expanded": payWithNewCard
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex items-center gap-3"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex h-8 w-8 items-center justify-center rounded-full border border-gray-100 bg-white text-xl font-semibold text-gray-600 shadow-[0_1px_4px_rgba(15,23,42,0.1)]"
  }, "+"), /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S",
    color: "grayMedium",
    "data-sentry-element": "Text",
    "data-sentry-source-file": "StoredCardsCheckout.tsx"
  }, t('label.pay_with_another_card'))), /*#__PURE__*/_react["default"].createElement("span", {
    className: "flex h-6 w-6 items-center justify-center rounded-full bg-gray-100",
    "aria-hidden": "true"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Icon, {
    type: payWithNewCard ? 'ChevronUp' : 'ChevronDown',
    size: "XS",
    color: "grayLight",
    "data-sentry-element": "Icon",
    "data-sentry-source-file": "StoredCardsCheckout.tsx"
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "overflow-hidden transition-[max-height,opacity] duration-300 ease-in-out ".concat(payWithNewCard ? 'max-h-[900px] opacity-100' : 'max-h-0 opacity-0'),
    "aria-hidden": !payWithNewCard
  }, hasOpenedNewCardForm && /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "stored-cards-new-card-content",
    className: "border-t border-gray-100 bg-white p-4"
  }, /*#__PURE__*/_react["default"].createElement(_BasisTheoryNewCardForm.BasisTheoryNewCardForm, {
    active: active && payWithNewCard,
    cardErrorOccured: cardErrorOccured,
    embedded: true,
    monthlySelectedPlan: installments.selectedMonths,
    onCardDetailsChange: setNewCardDetails,
    hasSavedCards: true,
    publicKey: publicKey
  }))))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "pb-0.5 opacity-70"
  }, /*#__PURE__*/_react["default"].createElement(_EncryptedNotice.EncryptedNotice, {
    available: canUseStoredCards,
    label: t('label.bt_form.encrypted_notice'),
    "data-sentry-element": "EncryptedNotice",
    "data-sentry-source-file": "StoredCardsCheckout.tsx"
  })))), /*#__PURE__*/_react["default"].createElement(_BtInstallmentsSelector.BtInstallmentsSelector, (0, _extends2["default"])({}, installments, {
    eligibilityFeedback: showStoredCardInstallmentsChecking ? 'loading' : 'checking',
    eligibilityStatus: showStoredCardInstallmentsChecking ? 'checking' : installments.eligibilityStatus,
    "data-sentry-element": "BtInstallmentsSelector",
    "data-sentry-source-file": "StoredCardsCheckout.tsx"
  })), cardErrorOccured && !payWithNewCard && /*#__PURE__*/_react["default"].createElement(_elements.MessageBox, {
    title: t('label.problems_paying'),
    borderColor: "warning"
  }, /*#__PURE__*/_react["default"].createElement(_elements.Text, {
    size: "S"
  }, t('text.suggestions_to_payment_problems'))), showAllCards && /*#__PURE__*/_react["default"].createElement(_SavedCardsDialog.SavedCardsDialog, {
    cards: visibleCards,
    currentSelectedCardId: selectedCard === null || selectedCard === void 0 ? void 0 : selectedCard.id,
    deleteDisabled: Boolean(pendingDeletion || deletionConfirmationCard),
    onClose: function onClose() {
      return setShowAllCards(false);
    },
    onConfirmSelection: function onConfirmSelection(cardId) {
      var card = visibleCards.find(function (candidate) {
        return candidate.id === cardId;
      });
      if (card) selectCard(card, true);else clearCardSelection();
      setShowAllCards(false);
    },
    onDeleteCard: requestCardDeletion,
    onOpenDeleteMode: _savedCards.trackCardDeleteClicked,
    onUndoDeleteCard: undoDelete,
    pendingDeleteCardId: (pendingDeletion === null || pendingDeletion === void 0 ? void 0 : pendingDeletion.phase) === 'undo' ? pendingDeletion.card.id : undefined,
    pendingDeleteRemainingSeconds: remainingSeconds,
    visible: true
  }), deletionConfirmationCard && /*#__PURE__*/_react["default"].createElement(_StoredCardDeletionDialog.StoredCardDeletionDialog, {
    card: deletionConfirmationCard,
    onCancel: function onCancel() {
      return setDeletionConfirmationCard(undefined);
    },
    onConfirm: confirmCardDeletion
  }), cvvOpen && selectedCard && selectedCardNeedsCvv && /*#__PURE__*/_react["default"].createElement(_StoredCardCvvDialog.StoredCardCvvDialog, {
    card: selectedCard,
    cvvComplete: cvvElement.isComplete,
    isSubmitting: storedCardSubmit.isSubmitting,
    onClose: function onClose() {
      return setCvvOpen(false);
    },
    onConfirm: /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var submitted;
      return _regenerator["default"].wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 1;
            return storedCardSubmit.submit();
          case 1:
            submitted = _context2.sent;
            if (submitted) setCvvOpen(false);
          case 2:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })),
    status: cvvElement.status,
    targetId: cvvElement.targetId
  }));
}